import { TRIGGERS_BY_TOPIC } from '../../constants';


export const getTriggerByApplyState = (topic: string, triggers: typeof TRIGGERS_BY_TOPIC['apply-state']) => {
  for (const key in triggers) {
    if (topic.startsWith(key) && key in triggers) {
      return triggers[key as keyof typeof triggers];
    }
  }

  console.error(`getApplyStateTrigger -> Trigger for an event of ${topic} was not found.`, triggers);
};
